import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { INotification } from "infrastructure/notification";
import { INotificationActionResult } from "infrastructure/store";

import {
  ISettingsState,
  IAppTranslationState,
  ITranslationMessages,
  ITranslationAttributes,
  IAppNotificationState,
  ITranslationMessagesLoadParam,
  getInitialSettingsState,
  getInitialAppTranslationState,
  getInitialAppNotificationState
} from "./app.state";

export const settings = createSlice({
  name: "settings",
  initialState: getInitialSettingsState(),
  reducers: {
    changeTheme: (state: ISettingsState, action: PayloadAction<string>) => {
      return {
        ...state,
        localSettings: {
          ...state.localSettings,
          theme: action.payload
        }
      };
    },
    changeLocale: (state: ISettingsState) => {
      return {
        ...state,
        localSettings: {
          ...state.localSettings,
          isLocaleChanging: true
        }
      };
    },
    changeLocaleCompleted: (state: ISettingsState, action: PayloadAction<string>) => {
      return {
        ...state,
        localSettings: {
          ...state.localSettings,
          locale: action.payload,
          isLocaleChanging: false
        }
      };
    },
    changeLocaleFailed: (state: ISettingsState, _action: PayloadAction<INotificationActionResult<string>>) => {
      return {
        ...state,
        localSettings: {
          ...state.localSettings,
          isLocaleChanging: false
        }
      };
    },
    initializeLocale: (state: ISettingsState, action: PayloadAction<string>) => {
      return {
        ...state,
        localSettings: {
          ...state.localSettings,
          locale: action.payload
        }
      };
    }
  }
});

export const appTranslation = createSlice({
  name: "appTranslation",
  initialState: getInitialAppTranslationState(),
  reducers: {
    loadMessageTranslations: (state: IAppTranslationState, _action: PayloadAction<ITranslationMessagesLoadParam>) => {
      return { ...state, isLoading: true };
    },
    loadMessageTranslationsCompleted: (state: IAppTranslationState, action: PayloadAction<ITranslationMessages>) => {
      return {
        ...state,
        messages: { ...state.messages, ...action.payload.messages },
        isLoading: false,
        isInitialized: true
      };
    },
    loadMessageTranslationsPartCompleted: (state: IAppTranslationState, action: PayloadAction<ITranslationAttributes>) => {
      state.attributes[action.payload.messagePrefix] = action.payload;
      return state;
    },
    loadMessageTranslationsFailed: (state: IAppTranslationState, _action: PayloadAction<INotificationActionResult<ITranslationMessages>>) => {
      return { ...state, isLoading: false, isInitialized: true };
    }
  }
});

export const appNotification = createSlice({
  name: "appNotification",
  initialState: getInitialAppNotificationState(),
  reducers: {
    showAppNotification: (state: IAppNotificationState, action: PayloadAction<INotification>) => {
      state.messages.push(action.payload);
      return state;
    },
    clearAppNotification: (state: IAppNotificationState) => {
      return { ...state, messages: [] };
    },
    removeAppNotification: (state: IAppNotificationState, action: PayloadAction<number>) => {
      state.messages.splice(action.payload, 1);
      return state;
    }
  }
});
